var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"header-notification"},[_vm._t("default"),_c('button',{staticClass:"link--simple hide-notification",on:{"click":_vm.acceptCookies}},[_vm._v(_vm._s(_vm.acceptCookiesLabel))])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }